import React, { Component } from "react"
import PropTypes from "prop-types"
import TwCitySelector from "tw-city-selector/tw-city-selector"

class RegisterPurchaseLocation extends Component {
  componentDidMount() {
    new TwCitySelector({
      el: ".purchase-location-selector",
      elCounty: ".county", // 在 el 裡查找 dom
      showDistrict: false,
    })
  }

  onCountyChange = (event) => {
    this.props.handleObjectChange({
      purchase_location_county: event.target.value,
    })
  }

  render() {
    const { country, name, valid } = this.props

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">購買地點</label>
        </div>
        <div className="field-body">
          <div className="field is-grouped purchase-location-selector">
            <div className="control">
              <div className="select">
                <select
                  className="county"
                  value={country}
                  onChange={this.onCountyChange}
                />
              </div>
            </div>
            <div className="control is-expanded">
              <input
                className={!valid ? "input" : "input is-success"}
                type="text"
                id="register-location-input"
                placeholder="店家"
                required
                value={name}
                onChange={(e) =>
                  this.props.handleObjectChange({
                    purchase_location_name: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <p className="help is-danger">必填</p>
      </div>
    )
  }
}

RegisterPurchaseLocation.propTypes = {
  handleObjectChange: PropTypes.func.isRequired,
}

export default RegisterPurchaseLocation



// WEBPACK FOOTER //
// ./src/components/RegisterPurchaseLocation.js